class OrgSetupOnboardingController {
  constructor(
    Authentication,
    PersonaCollection,
    AccountService,
    SlingAnalytics,
    TopSectionDisplay,
    WhatsNewService,
    IntegrationService,
    $timeout,
    $state,
    $scope,
    $rootScope,
    $location
  ) {
    'ngInject';

    Object.assign(this, {
      Authentication,
      PersonaCollection,
      AccountService,
      SlingAnalytics,
      TopSectionDisplay,
      WhatsNewService,
      IntegrationService,
      $timeout,
      $state,
      $scope,
      $rootScope,
      $location,
    });
  }

  $onInit() {
    this.user = this.Authentication.user;
    this.init();
    this.TopSectionDisplay.hide();
    this.toastIntegration = null;
  }

  $onDestroy() {
    this.TopSectionDisplay.show();
  }

  setToastData = (integrations) => {
    this.toastIntegration = integrations.find((integration) => integration.type === 'toast');
  };

  async init() {
    this.WhatsNewService.refreshAndMarkAsRead();

    await this.Authentication.userLoaded;
    await this.PersonaCollection.personaCollectionLoaded;

    this.user = { ...this.Authentication.user };

    this.saveClientFlags = async (flags) => {
      await this.Authentication.saveClientFlags(flags);
      this.user = { ...this.Authentication.user };
    };

    this.updateCurrentOrg = this.Authentication.updateCurrentOrg;
    this.updateCurrentUser = this.Authentication.updateCurrentUser;

    this.setFirstRun = () => {
      this.Authentication.firstRun = true;
    };
    this.loadPersonaCollection = () => this.PersonaCollection.loadData();

    this.addPersonaCollectionGroup = (group) => this.PersonaCollection.addGroup(group);
    this.addPersonaCollectionUser = (user) => this.PersonaCollection.addUser(user);
    this.onClose = () => {
      this.$rootScope.finishedOnboarding = true;
      this.$state.go('shifts');
    };

    const initialIntegrations = await this.IntegrationService.getAvailableIntegrations();
    this.setToastData(initialIntegrations);

    this.$rootScope.$on('integrations:updated', (event, integrations) => {
      this.setToastData(integrations);
    });

    this.$rootScope.$on('socket:integration:status', async (event, integration) => {
      if (integration.platform === 'toast') {
        const integrations = await this.IntegrationService.getAvailableIntegrations(true);
        this.setToastData(integrations);
      }
    });
  }

  get locations() {
    return this.PersonaCollection.locations;
  }

  get positions() {
    return this.PersonaCollection.positions;
  }
}

export default {
  template: `
    <r-onboarding
      ng-if="ctrl.user"
      user="ctrl.user"
      save-client-flags="ctrl.saveClientFlags(flags)"
      update-current-org="ctrl.updateCurrentOrg(org)"
      update-current-user="ctrl.updateCurrentUser(user)"
      set-first-run="ctrl.setFirstRun()"
      load-persona-collection="ctrl.loadPersonaCollection(refresh)"
      locations="ctrl.locations"
      positions="ctrl.positions"
      add-persona-collection-group="ctrl.addPersonaCollectionGroup(group)"
      add-persona-collection-user="ctrl.addPersonaCollectionUser(user)"
      on-close="ctrl.onClose()"
      toast-integration="ctrl.toastIntegration">
    </r-onboarding>
    `,
  controller: OrgSetupOnboardingController,
  controllerAs: 'ctrl',
};
